let obj = {};
obj.companyIdTypeOptions = [
  {
    value: '6',
    name: '社会统一信用代码'
  }
];
obj.ceryTypeList = [
  {
    value: '2',
    name: '增值税一般纳税人'
  },
  {
    value: '3',
    name: '非增值税纳税人'
  }
];
obj.invoiceprList = [
  {
    value: '01',
    text: '暂不开票'
  },
  {
    value: '03',
    text: '电子发票'
  }
];
obj.guarantPre = [
  {
    key: 1,
    value: '1个月'
  },
  {
    key: 2,
    value: '2个月'
  },
  {
    key: 3,
    value: '3个月'
  },
  {
    key: 4,
    value: '4个月'
  },
  {
    key: 5,
    value: '5个月'
  },
  {
    key: 6,
    value: '6个月'
  },
  {
    key: 7,
    value: '7个月'
  },
  {
    key: 8,
    value: '8个月'
  },
  {
    key: 9,
    value: '9个月'
  },
  {
    key: 10,
    value: '10个月'
  },
  {
    key: 11,
    value: '11个月'
  },
  {
    key: 12,
    value: '12个月'
  }
];
//投保职业及人数
obj.occupationNumberList = [
  {
    occupationKind: 1,
    personNum: 0
  },
  {
    occupationKind: 2,
    personNum: 0
  },
  {
    occupationKind: 3,
    personNum: 0
  },
  {
    occupationKind: 4,
    personNum: 0
  },
  {
    occupationKind: 5,
    personNum: 0
  },
  {
    occupationKind: 6,
    personNum: 0
  }
];
obj.IdTypeOptions = [
  {
    name: '身份证',
    value: '1'
  },
  {
    name: '军官证',
    value: '2'
  },
  {
    name: '港澳台证',
    value: '3'
  },
  {
    name: '护照',
    value: '4'
  },
  {
    name: '异常身份证',
    value: '5'
  },
  {
    name: '出生证',
    value: '6'
  },
  {
    name: '工商登记证',
    value: '7'
  },
  {
    name: '其他证件',
    value: '9'
  },
  {
    name: '港澳居民来往内地通行证',
    value: '41'
  },
  {
    name: '台湾居民来往内地通行证',
    value: '42'
  },
  {
    name: '外国人永久居留身份证',
    value: '43'
  },
  {
    name: '驾驶证',
    value: '44'
  },
  {
    name: '军人证',
    value: '45'
  },
  {
    name: '军人离休证',
    value: '46'
  },
  {
    name: '户口本',
    value: '47'
  },
  {
    name: '居住证',
    value: '48'
  },
  {
    name: '中国护照',
    value: '49'
  },
  {
    name: '港澳通行证',
    value: '50'
  },
  {
    name: '台湾通行证',
    value: '51'
  },
  {
    name: '港澳台居民居住证',
    value: '55'
  }
];
// 性别
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  },
  {
    value: '6',
    name: '6类'
  }
];
obj.columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '姓名',
    dataIndex: 'name'
  },
  {
    title: '证件类型',
    dataIndex: 'idType',
    key: 'idType',
    scopedSlots: { customRender: 'idType' }
  },
  {
    title: '证件号码',
    dataIndex: 'idNumber'
  },
  {
    title: '出生日期',
    dataIndex: 'birthDate'
  },
  {
    title: '性别',
    dataIndex: 'gender',
    key: 'gender',
    scopedSlots: { customRender: 'gender' }
  },
  {
    title: '职业代码',
    dataIndex: 'occupationCode'
  },
  {
    title: '职业名称',
    dataIndex: 'occupationName'
  },
  {
    title: '职业类别',
    dataIndex: 'occulevel',
    key: 'occulevel',
    scopedSlots: { customRender: 'occulevel' }
  }
];
// 投保人限制名称
obj.prohibitedIndustries = ['钢丝绳', '钢铁', '危险品', '脚手架', '幕墙', '钢结构', '电梯', '船舶', '船厂', '钢绳', '铸造', '钢管', '船务', '远洋渔业', '爆破', '船坞', '船业', '架设', '人力资源', '企业管理', '外包', '劳务', '派遣', '开采', '石材', '煤', '钻井', '土石方'];
export default { ...obj };
